import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router }   from '@angular/router';
import { Location }                 from '@angular/common';

import * as _ from 'lodash';

import 'rxjs/add/operator/switchMap';

import { CallService } from '../../services/calls/call.service';
import { RecordsService } from '../../services/records/records.service';
import { specialties } from '../../users/specialties.component'
import { Doctor } from '../../classes/doctor';
import { DoctorService } from '../../services/doctors/doctor.service';
import { SpecialtiesService } from '../../services/specialties/specialties.service';
import { AppConfig } from '../../app.config';
import { FilterService } from '../../services/calls/filter.service';
import { Auth } from '../../services/auth.service';

const moment = require('moment');
const MomentTimezone = require('moment-timezone');

enum gView {
  CALL_DETAILS,
  PRESCRIPTIONS,
  LOGS,
}

@Component({
  moduleId: module.id,
  selector: 'my-call-detail',
  templateUrl: 'call-detail.component.html',
  styleUrls: [ '../../users/detail/user-detail.component.css' ]
})

export class CallDetailComponent implements OnInit {

  call: any;
  _: any;
  loading:boolean=true
  changesAlert:boolean=false;
  records:Array<string> = [];

  allDoctors;
  selectedDoctorIndex;
  selectedDoctor:Doctor;

  doctorSpecialties;
  selectedSpecialtyIndex;
  selectedSpecialty;

  doctorName;
  doctorEmail;

  callDatetime;

  tokboxBaseUrl;
  urlFiles = [];
  instructions = [];
  sendFilesByWhatsapp;
  invalidatedCall;
  forceNotBillable: boolean = false;
  useFarmalink = false;
  callReportEmails: string;
  View = gView;
  logs = [];
  filteredLogs = [];
  logsFilter = '';
  logsLoaded: boolean = false;
  currentView = this.View.CALL_DETAILS;

  hasWriteCallsPermission:boolean = false;
  hasClinicalHistoryPermission:boolean = false;
  hasReportsPermission:boolean = false;

  validationMsg = {
    validate: "Esta seguro que desea validar la llamada?",
    invalidate: "Esta seguro que desea invalidar la llamada?",
    forceNotBillableTrue: "Esta seguro que desea marcar la llamada como no facturable (independientemente de los criterios de facturacion)?",
    forceNotBillableFalse: "Esta seguro que desea dejar de marcar la llamada como no facturable?",
  }

  constructor(
    protected callService: CallService,
    protected recordsService: RecordsService,
    protected route: ActivatedRoute,
    protected router: Router,
    protected location: Location,
    protected doctorsService: DoctorService,
    protected specialtiesService:SpecialtiesService,
    protected filterService: FilterService,
    protected config: AppConfig,
    protected auth: Auth
  ) {
    this.tokboxBaseUrl = this.config.get('TOKBOX_URL_BASE')
  }

  ngOnInit(): void {

    this.hasWriteCallsPermission = this.auth.hasWriteCallsPermission();
    this.hasClinicalHistoryPermission = this.auth.hasClinicalHistoryPermission();
    this.hasReportsPermission = this.auth.hasReportsPermission();

    this._ = _;

    this.route.params
      .switchMap((params: Params) => this.callService.getOne(params['id'])
      //.then(() => this.loading=false)
      )
      .subscribe((call) => {

        this.call = call;
        if(call.records) this.records = this.recordsService.getStringRecords(call.records);
        this.changeData()
        this.loading=false
        this.sendFilesByWhatsapp = this.canSendFilesByWhatsapp();
        this.invalidatedCall = (this.call.tags && this.call.tags.includes("INVALIDADA"));
        this.useFarmalink = call.provider.prescriptionIntegrationType == 'Farmalink';
        this.forceNotBillable = this.call.forceNotBillable;
        this.callService.getPrescriptionsPdfs(this.call.id).then(data =>{
          this.urlFiles = data
          this.urlFiles.forEach(file => {
            if(file.includes('instrucciones') && !_.includes(this.instructions, file)) this.instructions.push(file)
          })
        })
      });
      this.getSpecialties();
  }

  getSpecialties(){
    this.specialtiesService.getAll().then((response)=>{
      this.doctorSpecialties=response
    })
  }

  getTokboxSessionUrl(call){
    let project
    if(call.patientClient.includes("Mozilla") && call.patientClient.includes("iPhone"))
    {
      project = this.config.get("TOKBOX_PROJECT_KEY_H264")
    }
    else
    {
      project = this.config.get("TOKBOX_PROJECT_KEY")
    }

    return this.tokboxBaseUrl+project+"/session/"+call.session
  }

  sendMedicalCareRecord(): void {
    if (this.call.provider.supportsMedicalCareRecord){
      this.callService.sendMedicalCareRecord({callId: this.call.id}).then((response)=>{
        alert("Constancia enviada correctamente")
      })
      .catch((err)=>{
        alert(err);
      })
    } else {
      alert("El provider " + this.call.provider.name + " no soporta el envío de constancias médicas.")
    }
  }

  sendDoctorToPrescribe(call): void {
    if(this.call.provider.supportsPrescription || this.call.provider.supportsMedicalOrder) {
      this.callService.sendDoctorToPrescribe({callId: this.call.id,doctorId:this.call.doctor.id}).then((response)=>{
        alert("Email enviado correctamente")
      })
      .catch((err)=>{
        alert(err);
      })
    } else {
      alert("El provider " + this.call.provider.name + " no soporta ni el envío de recetas ni el envío de órdenes médicas.")
    }
  }

  changeData(){
    this.call.date=this.changeDate(this.call.date,this.call.createdAt);
    if(this.call.completionTime) this.call.completionDate=this.changeDate(this.call.completionTime, null);
    console.log("no tiene diagnoses")

    if (!this.call.hasOwnProperty("diagnosis")){
        this.call.diagnosis = {diagnosis:"No",solved:false,urgent:false,text:'Empty',referred:false, patientDischarged: false, consultationPreviouslySolved:false, wrongPhone:false, couldNotContact:false, discontinueMonitoring: false}
    }
    else{
        if (!this.call.diagnosis.text){
            this.call.diagnosis.text='Empty'
        }
    }

    if (!this.call.hasOwnProperty("doctor")){
        this.call.doctor = {name:'Deleted doctor'}
    }
    if (!this.call.hasOwnProperty("patient")){
        this.call.patient =  {name:'Deleted patient'}
    }

    //Convierto duracion a minutos y pongo maximo 2 decimales
    if (this.call.hasOwnProperty("doctorDuration")){
        this.call.doctorDuration = moment.utc(this.call.doctorDuration*1000).format('m:ss');
    }
    else this.call.doctorDuration = "?"

    if (this.call.hasOwnProperty("patientDuration")){
        this.call.patientDuration = moment.utc(this.call.patientDuration*1000).format('m:ss');
    }
    else this.call.patientDuration = "?"

    if (!this.call.hasOwnProperty("motive")){
        this.call.motive = "Empty"
    }

    if (!this.call.hasOwnProperty("doctorReputation")){
        this.call.doctorReputation = "-"
    }
    if (!this.call.hasOwnProperty("doctorStars")){
        this.call.doctorStars = "-"
    }
    if (!this.call.hasOwnProperty("patientStars")){
        this.call.patientStars = "-"
    }
    if (!this.call.hasOwnProperty("doctorDuration")){
        this.call.doctorDuration = "?"
    }
    if (!this.call.hasOwnProperty("patientDuration")){
        this.call.patientDuration = "?"
    }

    if (!this.call.hasOwnProperty("doctorText")){
        this.call.doctorText = 'Empty'
    }

    if (!this.call.hasOwnProperty("patientText")){
        this.call.patientText = 'Empty'
    }
      if (!this.call.hasOwnProperty("billable")){
        this.call.billable = false;
    }
    if(!this.call.hasOwnProperty("patientClient")){
      this.call.patientClient = 'Empty';
    }
  }

  changeDate(dateU:any,createdAt:any):string{
    if (dateU!=undefined){
        let date = new Date(dateU);
        let month: number;
        month = date.getMonth()+1
        var hours = date.getHours();
        var minutes = "0" + date.getMinutes();
        var seconds = "0" + date.getSeconds();
        // Will display time in 10:30:23 format
        var formattedTime = hours + ':' + minutes.substr(-2) + ':' + seconds.substr(-2);
        return date.getDate() + '/' + month+ '/' + date.getFullYear() + ' ' + formattedTime
    }
    console.log(createdAt.slice(8,10)+'/'+createdAt.slice(5,7)+'/'+createdAt.slice(0,4) +' '+createdAt.slice(11,19))
    return createdAt.slice(8,10)+'/'+createdAt.slice(5,7)+'/'+createdAt.slice(0,4) +' '+createdAt.slice(11,19)

}

  changeStatus(call){
    this.callService.update(call.id,{status:'ENDED'}).then((response)=>{
      this.call.status = response.status;
    })
  }

  resolveCallSameDoctor(): void {
    var datetime = moment(this.callDatetime).toISOString();
    var body = {
      manual: true,
      call: this.call.id,
      doctor: this.call.doctor.id,
      patient: this.call.patient.id,
      provider: this.call.patient.provider,
      createdAt: datetime
    }
    this.createCall(body)
  }

  resolveCallAnotherDoctor(): void {
    var datetime = moment(this.callDatetime).toISOString();
    var body = {
      manual: true,
      call: this.call.id,
      doctor: this.selectedDoctor.id,
      patient: this.call.patient.id,
      provider: this.call.patient.provider,
      createdAt: datetime
    }
    this.createCall(body)
  }

  private createCall(body):void{
    this.callService.createCall(body).then((response)=>{
      alert("success");
      window.location.reload()
    })
    .catch((err)=>{
      return err && err._body ?
            (err._body.message ? alert(err._body.message) : alert(err))
            : alert(err);
    })
  }

  doctorSelected(event): void {
    this.selectedDoctor = this.allDoctors[this.selectedDoctorIndex];
  }

  specialtySelected(event): void {
    if(this.selectedSpecialtyIndex != 0)
      this.selectedSpecialty = this.doctorSpecialties[this.selectedSpecialtyIndex-1];
    else
      this.selectedSpecialty = undefined;
  }

  searchDoctors(): void {
    let params = {};

    if(this.doctorName) params['name'] = this.doctorName;
    if(this.doctorEmail) params['email'] = this.doctorEmail;
    if(this.selectedSpecialty) params['specialty'] = this.selectedSpecialty.id;

    this.doctorsService.get(params).then((doctors: any[]) => this.allDoctors = doctors)
  }

  resetDoctors() {
    this.doctorName = undefined;
    this.doctorEmail = undefined;
    this.selectedSpecialtyIndex = undefined;
    this.doctorsService.get({limit:150}).then((doctors: any[]) => this.allDoctors = doctors)
  }

  togglePrescription(){
    this.callService.update(this.call.id,{isPrescription: !this.call.isPrescription}).then((response)=>{
      this.call.isPrescription = response.isPrescription;
    })
  }

  deleteFarmalinkPrescription(prescriptionId): void {
    this.callService.deleteFarmalinkPrescription({call: this.call.id,prescription: prescriptionId}).then((response)=>{
      var message = response.context ? response.context.descripcionError : response.descripcion;
      alert(message)
    }).catch((err)=>{
      console.log(err)
      alert(err);
    })
  }

  resendFarmalinkPrescription(prescriptionId): void {
    this.callService.resendFarmalinkPrescription({call: this.call.id, prescription: prescriptionId}).then((response)=>{
      var message = response.context ? response.context.descripcionError : response.descripcion;
      alert(message)
    }).catch((err)=>{
      console.log(err)
      alert(err);
    })
  }

  sendFileCalls(){
    if(this.urlFiles.length == 0) return alert('Esta llamada no posee archivos disponibles!')
    this.callService.sendFilesToMail(this.call.id).then( response => {
      alert(response.message)
    }).catch(err => {
      alert(err);
    })
  }

  getFileType(fileKey) {
    const keys = {
      duplicado: 'Duplicado',
      recetas: 'Receta',
      instrucciones: 'Instrucciones médicas',
      ordenes: 'Órden médica',
      constancias: 'Constancia médica'
    }
    for (const key in keys) {
      if(fileKey.includes(key)) return keys[key]
    }
  }

  getUrlFile(fileKey) {
    return this.urlFiles.find(url => url.includes(fileKey))
  }

  getCurrentDate(){
    this.callDatetime = this.filterService.getCurrentDate();
  }

  canSendFilesByWhatsapp(){
    return (!_.isEmpty(this.call.prescriptions) && this.call.provider.sendPrescriptionByWhatsApp)
        || (!_.isEmpty(this.call.medicalOrders) && this.call.provider.sendOrderByWhatsApp)
        || (!_.isEmpty(this.call.medicalCareRecord) && this.call.provider.sendMedicalCareRecordByWhatsApp)
  }

  notifyToSendFilesByWhatsApp() {
    const notify = {
      sendPrescriptions: this.call.provider.sendPrescriptionByWhatsApp,
      sendOrders: this.call.provider.sendOrderByWhatsApp,
      sendMedicalCareRecords: this.call.provider.sendMedicalCareRecordByWhatsApp
    }

    return this.callService.notifyToSendFilesByWhatsApp(this.call.id, notify)
    .then(() => alert("Archivos reenviados correctamente!"))
    .catch(() => alert("Ocurrió un error al reenviar los archivos, por favor espere un momento y vuelva a intentarlo."))
  }

  setInvalidCall() {
    const params = { tag: "INVALIDADA" };
    const action = this.invalidatedCall ? "validate" : "invalidate";
    let confirm = window.confirm(this.validationMsg[action]);
    let validationPromise;

    if(!confirm) { return this.invalidatedCall = !this.invalidatedCall };

    validationPromise = this.invalidatedCall ?
                        this.callService.validate(this.call.id, params):
                        this.callService.invalidate(this.call.id, params)

    return validationPromise
    .then( res => location.reload())
    .catch( err => {
      return err && err._body ?
              (err._body.message ? alert(err._body.message) : alert(err))
              : alert(err);
    })
  }

  setForceNotBillable() {
    this.forceNotBillable = !this.forceNotBillable;
    const action = this.forceNotBillable ? "forceNotBillableTrue" : "forceNotBillableFalse";
    let confirm = window.confirm(this.validationMsg[action]);

    if(!confirm) { return this.forceNotBillable = !this.forceNotBillable };

    const params = { forceNotBillable: this.forceNotBillable };
    return this.callService.setForceNotBillable(this.call.id, params)
    .then( res => location.reload())
    .catch( err => {
      return err && err._body ?
              (err._body.message ? alert(err._body.message) : alert(err))
              : alert(err);
    })
  }

  sendCallReportEmail() {
    if(!this.callReportEmails || this.callReportEmails === "") {
      return alert("Debe ingresar uno o mas emails separados por coma");
    }

    return this.callService.sendCallReportEmail(this.call.id, this.callReportEmails)
    .then(() => alert("Se ha enviado el reporte en formato pdf al email seleccionado."))
    .catch(() => alert("Ocurrió un error al enviar el reporte."))
  }

  changeView(param) : void {
    if(param == this.View.LOGS && !this.logsLoaded) {
      this.loadLogs()
    }

    this.currentView = param;
  }

  loadLogs() {
    this.callService.getCallLogs(this.call.id).then(logs =>{
      let mappedLogs = _.map(logs, (log:any) => {
        let mappedLog = {
          category: log.category,
          createdAt: moment(log.createdAt).format("YYYY-MM-DD HH:mm:ss"),
          log: log.log,
        }
        return mappedLog;
      })
      this.logs = _.orderBy(mappedLogs, (a:any) => a.createdAt, 'desc')
      this.filteredLogs = this.logs;
      this.logsLoaded = true;
    })
  }

  filterLogs() {
    if (this.logsFilter.length >= 3) {
      let lowerCaseFilter = this.logsFilter.toLowerCase()
      this.filteredLogs = this.logs.filter((log: any) => {
        return log.log.toLowerCase().includes(lowerCaseFilter) || log.category.toLowerCase().includes(lowerCaseFilter);
      });
    } else if (this.logsFilter == '') {
      this.filteredLogs = this.logs;
    }
 }

 filterPrescriptionLogs(prescriptionId) {
    this.logsFilter = prescriptionId;
    this.changeView(this.View.LOGS);
    this.filterLogs();
 }

 navigateTo(param, model) {
  this.router.navigate([`/${model}/${param}`]);
 }

 openNewTab(param, model) {
    const url = this.router.serializeUrl(
      this.router.createUrlTree([`/${model}/${param}`])
    )

    window.open(url, '_blank');
  }

  getUrlFor(model, param) {
    let url = this.router.serializeUrl(
      this.router.createUrlTree([`/${model}/${param}`])
    )

    return url;
  }



}



// WEBPACK FOOTER //
// ./src/app/calls/detail/call-detail.component.ts